import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { mealDateIso } from '@/helper/cartFamily';

/**
 * Clear search and collection drill-down when child, meal date, or serving
 * time changes (PA2-05). Keeps the category chip. Caller clears local search
 * via onReset.
 */
export default function useResetMenuBrowse(onReset) {
	const dispatch = useDispatch();
	const customerId = useSelector((state) => state.auth.selectedCustomerId);
	const orderDate = useSelector((state) => state.cart.orderDate);
	const menuServingTimeId = useSelector((state) => state.cart.menuServingTimeId);
	const dateIso = mealDateIso(orderDate);
	const onResetRef = useRef(onReset);
	const ready = useRef(false);

	useEffect(() => {
		onResetRef.current = onReset;
	}, [onReset]);

	useEffect(() => {
		if (!ready.current) {
			ready.current = true;
			return;
		}
		dispatch({ type: 'cart/resetMenuBrowse' });
		if (typeof onResetRef.current === 'function') onResetRef.current();
		const scroller = document.querySelector('.food-grids.scrollable');
		if (scroller) scroller.scrollTop = 0;
		window.scrollTo(0, 0);
	}, [customerId, dateIso, menuServingTimeId, dispatch]);
}
